import {
  AUTH_TOKEN,
  REFRESH_TOKEN,
  EXPIRE_TIME,
  FIREBASE_TOKEN,
  USER_ROLES,
  SYSTEM_ROLES,
} from "constants/AuthConstant";
import { isString } from "lodash";

export const setAuthenData = (data) => {
  const token = data.tokenData.token;
  localStorage.setItem(AUTH_TOKEN, token);
  const refreshToken = data.tokenData.refreshToken;
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  const expiredTime = data.tokenData.expires;
  localStorage.setItem(EXPIRE_TIME, expiredTime);
  const firebaseToken = data.firebaseToken;
  localStorage.setItem(FIREBASE_TOKEN, firebaseToken);
  localStorage.setItem(USER_ROLES, data.userRoles);
};

export const getExtension = (fileName, indexOf = 0) => {
  let fileExt = "";
  const dotLastIdx = fileName.lastIndexOf(".");
  if (dotLastIdx >= 0) fileExt = fileName.substring(dotLastIdx + indexOf);

  return fileExt;
};
export const makeRandomId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
export const getNameWithoutExtension = (fileName) => {
  return fileName.substr(0, fileName.lastIndexOf("."));
};

export const formatInputMoney = (n) => {
  if (n <= 0) return 0;
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const formatMoney = (n) => {
  const price = isString(n) ? +n : n;
  if (price < 0) return 0;
  return price?.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
  });
};

export const formatVND = (value) => {
  if (typeof value !== "number" || !isFinite(value)) return "0 đ";

  return value.toLocaleString("vi-VN") + " đ";
};

export const formatMoneyDecimal = (value, digits = 2) =>
  (Number(value) || 0).toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });

export const formatNumberDecimal = (value, digits = 2) =>
  (Number(value) || 0).toLocaleString("vi-VN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });

export const moneyInputFormatter = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const [integer, decimal] = `${value}`.split(".");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return decimal !== undefined ? `${grouped},${decimal}` : grouped;
};

export const moneyInputParser = (value) =>
  `${value ?? ""}`.replace(/\s|đ/g, "").replace(/\./g, "").replace(",", ".");

const MONEY_DIGITS = [
  "không",
  "một",
  "hai",
  "ba",
  "bốn",
  "năm",
  "sáu",
  "bảy",
  "tám",
  "chín",
];

const readMoneyThreeDigits = (number, full) => {
  const hundred = Math.floor(number / 100);
  const ten = Math.floor((number % 100) / 10);
  const unit = number % 10;

  let result = "";

  if (full || hundred > 0) {
    result += `${MONEY_DIGITS[hundred]} trăm`;

    if (ten === 0 && unit > 0) result += " lẻ";
  }

  if (ten > 1) {
    result += ` ${MONEY_DIGITS[ten]} mươi`;
    if (unit === 1) result += " mốt";
  } else if (ten === 1) {
    result += " mười";
    if (unit === 1) result += " một";
  }

  if (unit === 5 && ten > 0) {
    result += " lăm";
  } else if (unit === 4 && ten > 1) {
    result += " tư";
  } else if (unit > 1 || (unit === 1 && ten === 0)) {
    result += ` ${MONEY_DIGITS[unit]}`;
  }

  return result.trim();
};

export const readMoneyToWords = (amount) => {
  const value = Math.round(Number(amount) || 0);

  if (value === 0) return "Không đồng";

  const unitName = (position) =>
    ["", " nghìn", " triệu"][position % 3] +
    " tỷ".repeat(Math.floor(position / 3));
  const groups = [];
  let rest = value;

  while (rest > 0) {
    groups.unshift(rest % 1000);
    rest = Math.floor(rest / 1000);
  }

  let words = "";

  groups.forEach((group, index) => {
    const isLast = index === groups.length - 1;

    if (group === 0) return;

    words += readMoneyThreeDigits(
      group,
      !isLast && index !== 0 ? true : index > 0,
    );
    words += unitName(groups.length - 1 - index);
    words += " ";
  });

  words = words.trim().replace(/\s+/g, " ");
  words = words.charAt(0).toUpperCase() + words.slice(1);

  return `${words} đồng`;
};

export const calculateDifferentQuantity = (materials, products, tools) => {
  let realQuantity = 0;
  let systemQuantity = 0;
  let positiveQuantity = 0;
  let nagativeQuantity = 0;

  const calculate = (items) => {
    if (!Array.isArray(items)) return;

    items.forEach((item) => {
      const real = parseFloat(item.realQuantity) || 0;
      const system = parseFloat(item.systemQuantity) || 0;

      realQuantity += real;
      systemQuantity += system;

      const difference = system - real;

      if (difference > 0) {
        positiveQuantity += difference;
      } else if (difference < 0) {
        nagativeQuantity += difference;
      }
    });
  };

  calculate(materials);
  calculate(products);
  calculate(tools);

  return {
    realQuantity,
    systemQuantity,
    nagativeQuantity,
    positiveQuantity,
  };
};

export const getFirstChildPath = (items = []) => {
  if (!Array.isArray(items)) return null;

  for (const item of items) {
    if (!item) continue;

    if (item.children?.length > 0) {
      const childPath = getFirstChildPath(item.children);
      if (childPath) return childPath;
    }

    if (item.path) return item.path;
  }

  return null;
};

export const findMenuPath = (items = [], targetPath) => {
  for (const item of items) {
    if (item.path === targetPath) return item.path;

    if (item.children?.length > 0) {
      const result = findMenuPath(item.children, targetPath);

      if (result) return result;
    }
  }
  return null;
};

export const getSideNavMenuItem = (
  navItem,
  userRoles,
  profile,
  permissions = [],
  currentWorkspace,
) => {
  const roles = Array.isArray(userRoles)
    ? userRoles.map(Number)
    : String(userRoles || "")
        .split(",")
        .map((role) => Number(role.trim()))
        .filter((role) => !Number.isNaN(role));

  const isOperatorAdmin = roles.includes(SYSTEM_ROLES.OperatorAdmin);

  return navItem
    .map((nav) => {
      if (isOperatorAdmin) {
        if (nav.roles?.length > 0) {
          const hasRole = nav.roles.some((menuRole) =>
            roles.includes(menuRole),
          );

          if (!hasRole) {
            return null;
          }
        }
      } else {
        const hasChildren = nav.submenu?.length > 0;

        if (!hasChildren) {
          if (nav.permission?.length > 0) {
            const hasPermission = nav.permission.some((permission) =>
              permissions.includes(permission),
            );

            if (!hasPermission) {
              return null;
            }
          } else {
            return null;
          }

          if (nav.workspace?.length > 0) {
            const hasWorkspace = nav.workspace.includes(currentWorkspace);

            if (!hasWorkspace) {
              return null;
            }
          } else {
            return null;
          }
        }
      }

      const children = nav.submenu?.length
        ? getSideNavMenuItem(
            nav.submenu,
            userRoles,
            profile,
            permissions,
            currentWorkspace,
          )
        : [];

      if (nav.submenu?.length > 0 && children.length === 0) {
        return null;
      }

      const isDisabled =
        nav.key === "admin-settings-invoice" &&
        profile?.subscriptionInfo?.limitedModule?.includes("MANAGE_INVOICE") &&
        !profile?.subscriptionInfo?.isTrial;

      return {
        key: nav.key,
        path: nav.path,
        ...(nav.isGroupTitle ? { type: "group" } : {}),
        ...(children.length > 0 ? { children } : {}),
        disabled: isDisabled,
      };
    })
    .filter(Boolean);
};

export const hasRolePermission = (
  listPermissions = [],
  workspace,
  companyPermissions = [],
  purchasingPermissions = [],
  branchPermissions = [],
) => {
  if (!Array.isArray(listPermissions)) return false;
  if (!workspace) return false;
  let permissions = [];

  switch (workspace) {
    case "company":
      permissions = companyPermissions;
      break;
    case "purchasing":
      permissions = purchasingPermissions;
      break;
    case "branch":
      permissions = branchPermissions;
      break;
    default:
      return false;
  }

  return permissions.some((permission) => listPermissions.includes(permission));
};
